package tta.destinigo.talktoastro.feature_post.di

import org.koin.dsl.module
import tta.destinigo.talktoastro.feature_post.data.post_api_service.PostApiService
import tta.destinigo.talktoastro.feature_post.domain.PostListRepo

val PostModel = module {
    factory { PostListRepo(get()) }
    factory { PostApiService() }
}